<template>
  <div :class="$style.wrapper">
    <Typography :class="$style.text" :variant="TYPOGRAPHY_TYPES.bodyBold">
      {{
        $i18n(
          'Voulez vous voir votre ancien abonnement ou reprendre un nouvel abonnement ?',
        )
      }}
    </Typography>

    <div :class="$style.buttonsWrapper">
      <Button @click="resumeOldSubscription">
        {{ $i18n('Voir mon ancien abonnement') }}
      </Button>

      <Link :link="addPetLink">
        <Button>{{ $i18n('Nouveau départ') }}</Button>
      </Link>
    </div>
  </div>
</template>

<script>
import { RESUBSCRIBE_CONTEXT } from '@front/common/constants'
import { FlowType } from '@front/common/types'
import { PROFILE_BUILDER_URL } from '@front/common/urls'
import { Button, Typography, TYPOGRAPHY_TYPES } from '@front/ui'
import { computed, defineComponent, toRefs } from '@vue/composition-api'
import { useStore } from '@vueblocks/vue-use-vuex'
import urlcat from 'urlcat'

import Link from '@member-area/components/Link.vue'
import useCustomer from '@member-area/core/resources/Customer/Customer.hook'
import { MEMBER_AREA_ROUTE_HOMEPAGE } from '@member-area/core/routes-names'

export default defineComponent({
  components: { Typography, Button, Link },
  props: {
    name: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { name } = toRefs(props)
    const store = useStore()
    const { customer } = useCustomer()

    function resumeOldSubscription() {
      if (this.$route.name !== MEMBER_AREA_ROUTE_HOMEPAGE) {
        this.$router.push({ name: MEMBER_AREA_ROUTE_HOMEPAGE })
      }

      store.dispatch('modal/close', name.value)
    }

    const addPetLink = computed(() => {
      return urlcat(PROFILE_BUILDER_URL, {
        editingMode: FlowType.creation,
        customerId: customer.value?.id,
        standardisation: customer.value.flags?.standardised_food,
        context: RESUBSCRIBE_CONTEXT,
      })
    })

    return {
      TYPOGRAPHY_TYPES,
      resumeOldSubscription,
      addPetLink,
    }
  },
})
</script>

<style lang="scss" module>
.wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.text {
  text-align: center;
}

.buttonsWrapper {
  display: flex;
  flex-direction: column;
  margin-top: $ds-spacing-md;
  gap: $ds-spacing-xs;

  @media #{map-get($display-breakpoints, 'm-and-up')} {
    gap: $ds-spacing-md;
    flex-direction: row;
  }
}
</style>
